import { accountKeys } from '@taler/api-client'
import type { Locale } from '@taler/domain'
import { useQuery } from '@tanstack/vue-query'
import { computed, type ComputedRef } from 'vue'
import { useApi } from '@/app/api'
import { type AccountOption, flattenStatementAccounts } from '../internal/account-options.ts'

export interface UseImportAccountsOptions {
  readonly ledgerId: () => string
  readonly locale: () => Locale
  readonly enabled: () => boolean
}

export interface UseImportAccounts {
  /** Currency-bearing ASSET/LIABILITY accounts - the job's own statement account. */
  readonly statementOptions: ComputedRef<readonly AccountOption[]>
}

export function useImportAccounts(options: UseImportAccountsOptions): UseImportAccounts {
  const api = useApi()

  const treeQuery = useQuery({
    queryKey: computed(() => accountKeys.tree(options.ledgerId())),
    queryFn: ({ signal }) => api.accounts.tree(options.ledgerId(), signal),
    enabled: computed(options.enabled),
  })

  return {
    statementOptions: computed(() => flattenStatementAccounts(treeQuery.data.value ?? [], options.locale())),
  }
}
